import { React, useEffect, useState } from "react";
import TabContent from "../../../../layout/Tabs/TabContent";
import TabHeader from "../../../../layout/Tabs/TabHeader";
import TabBody from "../../../../layout/Tabs/TabBody";
import TabLink from "../../../../layout/Tabs/TabLink";
import { useFormik } from "formik";
import { useParams } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import crudApi from "@serie3/common/api/crudApi";
import Contacts from "../Shared/Components/Contacts";
import Media from "../Shared/Components/Media";
import {
  faPhone,
  faHouse,
  faHashtag,
  faComment,
  faUserTie,
  faPencil,
  faCake,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SaveButton from "../../../../layout/Buttons/SaveButton";
import NewModal from "../../documents/modals/NewModal";
import Adresses from "../Shared/Components/Addresses";
import Comments from "../Shared/Components/Comments";
import PersonForm from "@serie3/freelancesplaceapi/Form/Crm/PersonForm";
import PersonBasicsForm from "./PersonBasicsForm";
import Content from "../../../../layout/Content";
import ContentHeader from "../../../../layout/ContenteHeader";
import AiResearchButton from "../Shared/AiResearchButton";

const InfoRow = ({ label, value }) => {
  if (!value) return null;
  return (
    <div style={{
      display: "flex", justifyContent: "space-between", alignItems: "center",
      padding: "10px 0", borderBottom: "1px solid #f0f0f0",
    }}>
      <span style={{ fontSize: "0.78rem", fontWeight: 600, color: "#9e9e9e", textTransform: "uppercase", letterSpacing: "0.05em" }}>
        {label}
      </span>
      <span style={{ fontSize: "0.88rem", fontWeight: 600, color: "#424242" }}>
        {value}
      </span>
    </div>
  );
};

const Edit = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [person, setPerson] = useState();
  const [contactData, setContactData] = useState();
  const [mediaData, setMediaData] = useState();
  const [addressData, setAddressData] = useState();
  const [commentsData, setCommentsData] = useState();
  const [showEdit, setShowEdit] = useState(false);
  const prefix = "crm-person";
  let { id } = useParams();
  const editPersonForm = PersonForm.createPersonForm();
  const formik = useFormik(editPersonForm);

  useEffect(() => {
    const loadData = async (id) => {
      const person = await crudApi.show("/crm/person/show/", id);
      setPerson(person);
      setContactData(person.kontaktdaten);
      setMediaData(person.soziale_medien);
      setAddressData(person.adresse);
      setCommentsData(person.kommentare);
      formik.setValues(PersonForm.setEditData(person));
      setIsLoaded(true);
    };
    loadData(id);
  }, [id]);

  const handleSave = (e) => {
    formik.handleSubmit(e);
    if (Object.keys(formik.errors).length === 0) setShowEdit(false);
    e.preventDefault();
  };

  const SaveBasicsButton = () => (
    <SaveButton handleClick={(e) => { handleSave(e); }} />
  );

  const vorname = formik.values.vorname || "";
  const nachname = formik.values.name || "";
  const anrede = formik.values.anrede || "";
  const position = formik.values.position || "";
  const birthday = formik.values.geburtstag || "";
  const personName = [vorname, nachname].filter(Boolean).join(" ") || "Person";
  const initials = [vorname[0], nachname[0]].filter(Boolean).join("").toUpperCase();
  const title = () => personName;

  return !isLoaded ? null : (
    <>
      <NewModal show={showEdit} setShow={setShowEdit} ExtraButton={SaveBasicsButton}>
        <PersonBasicsForm formik={formik} />
      </NewModal>

      <ContentHeader>
        <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
          <div style={{
            width: "46px", height: "46px", borderRadius: "12px",
            background: "linear-gradient(135deg, #7b1fa2 0%, #4a148c 100%)",
            color: "#fff", display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: "1.2rem", flexShrink: 0, boxShadow: "0 4px 12px rgba(123,31,162,0.3)",
          }}>
            <FontAwesomeIcon icon={faUserTie} />
          </div>
          <div>
            <div style={{ fontSize: "1.5rem", fontWeight: 800, color: "#212121", lineHeight: 1.2 }}>
              {personName}
            </div>
            <div style={{ fontSize: "0.85rem", color: "#9e9e9e", marginTop: "2px" }}>
              CRM · People
            </div>
          </div>
        </div>
      </ContentHeader>

      <Content Title={title}>
        <Row>
          <Col className="col-md-3">
            <div style={{
              background: "#fff", borderRadius: "16px",
              boxShadow: "0 2px 16px rgba(0,0,0,0.08)",
              overflow: "hidden", marginBottom: "16px",
            }}>
              {/* Top banner */}
              <div style={{
                height: "72px",
                background: "linear-gradient(135deg, #7b1fa2 0%, #4a148c 100%)",
              }} />
              <div style={{ padding: "0 24px 24px", position: "relative" }}>
                {/* Avatar */}
                <div style={{
                  width: "64px", height: "64px", borderRadius: "50%",
                  background: "linear-gradient(135deg, #7b1fa2, #4a148c)",
                  border: "3px solid #fff",
                  color: "#fff", display: "flex", alignItems: "center",
                  justifyContent: "center", fontWeight: 800, fontSize: "1.2rem",
                  marginTop: "-32px", marginBottom: "12px",
                  boxShadow: "0 4px 12px rgba(123,31,162,0.3)",
                }}>
                  {initials || <FontAwesomeIcon icon={faUserTie} />}
                </div>

                {anrede && (
                  <div style={{ fontSize: "0.75rem", color: "#9e9e9e", fontWeight: 600, marginBottom: "2px" }}>
                    {anrede}
                  </div>
                )}
                <div style={{ fontWeight: 800, fontSize: "1.05rem", color: "#212121", marginBottom: "4px" }}>
                  {personName}
                </div>
                {position && (
                  <div style={{
                    display: "inline-block", fontSize: "0.72rem", fontWeight: 700,
                    padding: "2px 10px", borderRadius: "99px",
                    background: "#f3e5f5", color: "#7b1fa2", marginBottom: "16px",
                  }}>
                    {position}
                  </div>
                )}

                <div style={{ marginBottom: "16px" }}>
                  {birthday && (
                    <div style={{
                      display: "flex", alignItems: "center", gap: "7px",
                      padding: "10px 0", borderBottom: "1px solid #f0f0f0",
                    }}>
                      <FontAwesomeIcon icon={faCake} style={{ fontSize: "0.75rem", color: "#9e9e9e" }} />
                      <span style={{ fontSize: "0.88rem", fontWeight: 600, color: "#424242" }}>{birthday}</span>
                    </div>
                  )}
                </div>

                <button
                  type="button"
                  onClick={() => setShowEdit(true)}
                  style={{
                    width: "100%", padding: "9px", border: "none",
                    borderRadius: "10px", fontWeight: 700, fontSize: "0.88rem",
                    background: "#f3e5f5", color: "#7b1fa2", cursor: "pointer",
                    display: "flex", alignItems: "center", justifyContent: "center", gap: "7px",
                    transition: "background 0.15s",
                  }}
                  onMouseOver={e => e.currentTarget.style.background = "#e8c8f0"}
                  onMouseOut={e => e.currentTarget.style.background = "#f3e5f5"}
                >
                  <FontAwesomeIcon icon={faPencil} style={{ fontSize: "0.75rem" }} />
                  Edit Basics
                </button>
                <div style={{ marginTop: "8px" }}>
                  <AiResearchButton
                    personId={person.id}
                    formik={formik}
                    setContactData={setContactData}
                    setAddressData={setAddressData}
                    setMediaData={setMediaData}
                  />
                </div>
              </div>
            </div>
          </Col>

          <Col className="col-md-9">
            <div style={{
              background: "#fff", borderRadius: "16px",
              boxShadow: "0 2px 16px rgba(0,0,0,0.08)", overflow: "hidden",
            }}>
              <TabHeader prefix={prefix}>
                <TabLink prefix={prefix} name={"Comments"} icon={faComment} />
                <TabLink prefix={prefix} name={"Contact"} icon={faPhone} />
                <TabLink prefix={prefix} name={"Address"} icon={faHouse} />
                <TabLink prefix={prefix} name={"Media"} icon={faHashtag} />
              </TabHeader>
              <TabBody>
                <TabContent prefix={prefix} name={"Comments"} show={true}>
                  <Comments commentsData={commentsData} setCommentsData={setCommentsData} personId={person.id} companyId={null} />
                </TabContent>
                <TabContent prefix={prefix} name={"Contact"}>
                  <Contacts contactData={contactData} setContactData={setContactData} personId={person.id} companyId={null} />
                </TabContent>
                <TabContent prefix={prefix} name={"Address"}>
                  <Adresses addressData={addressData} setAddressData={setAddressData} personId={person.id} companyId={null} />
                </TabContent>
                <TabContent prefix={prefix} name={"Media"}>
                  <Media dataList={mediaData} setDataList={setMediaData} personId={person.id} companyId={null} />
                </TabContent>
              </TabBody>
            </div>
          </Col>
        </Row>
      </Content>
    </>
  );
};

export default Edit;
